var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.695 8.288a1.031 1.031 0 0 0-1.458 0L12 13.525 6.763 8.288a1.031 1.031 0 1 0-1.458 1.458l5.966 5.966a1.031 1.031 0 0 0 1.458 0l5.966-5.966a1.031 1.031 0 0 0 0-1.458Z",
    fill: "currentColor"
  })));
};
export default SvgChevronDown;